{
  "de": {
    "admin": {
      "features": {
        "title": "Feature Flags",
        "description": "Feature Flags für deinen Account aktivieren oder deaktivieren. Änderungen werden beim nächsten Seitenaufruf wirksam.",
        "search": "Features suchen...",
        "noResults": "Keine Features gefunden.",
        "activatedForYou": "Bereits für dich aktiviert",
        "globallyActive": "Für alle aktiviert",
        "tabsLabel": "Feature-Flag-Bereiche",
        "tabs": {
          "mine": "Meine Features",
          "management": "Feature-Flag-Verwaltung",
          "permanent": "Permanente Flags"
        }
      },
      "featureFlags": {
        "description": "Feature Flags für alle Nutzer:innen – nicht nur für deinen eigenen Account (anders als im Tab „Meine Features“).",
        "permanentDescription": "Dauerhafte Infrastruktur-Flags (z. B. OAuth-Login-Anbieter) für alle Nutzer:innen – ohne Aufräum-Workflow oder Aktivierungsdatum.",
        "search": "Flags durchsuchen...",
        "noResults": "Keine Feature Flags gefunden.",
        "activatedAt": "Aktiviert am {date}",
        "reviewWarning": {
          "title": "Diese Feature Flags sollten überprüft und ggf. entfernt werden:",
          "staleActivation": "vor über einer Woche aktiviert"
        },
        "state": {
          "on": "Aktiviert",
          "conditional": "Teilweise aktiviert",
          "off": "Deaktiviert"
        },
        "gatesSummary": {
          "actors": "{count} Nutzer:in | {count} Nutzer:innen",
          "groups": "{count} Gruppe | {count} Gruppen",
          "percentageOfActors": "{value} % der Nutzer:innen",
          "percentageOfTime": "{value} % der Zeit"
        },
        "detail": {
          "title": "Flag verwalten: {name}",
          "booleanSection": "Vollständig aktiviert",
          "booleanHint": "Schaltet das Flag für alle Nutzer:innen an oder aus.",
          "enabledLabel": "Für alle aktiviert",
          "actorsSection": "Einzelne Nutzer:innen",
          "actorsHint": "Nutzer:innen suchen und freischalten.",
          "actorsSearchLabel": "Nutzer:in suchen",
          "actorsSearchPlaceholder": "Name oder E-Mail eingeben...",
          "actorUnresolved": "Unbekannte:r Nutzer:in",
          "removeActor": "Entfernen",
          "groupsSection": "Gruppen",
          "percentageOfActorsSection": "Prozentsatz der Nutzer:innen",
          "percentageOfTimeSection": "Prozentsatz der Zeit",
          "percentageSave": "Speichern",
          "clearGates": "Alle Freischaltungen zurücksetzen",
          "clearGatesConfirm": "Alle Freischaltungen (Nutzer:innen, Gruppen, Prozentsätze) für „{name}“ wirklich zurücksetzen? Das kann nicht rückgängig gemacht werden.",
          "clearGatesConfirmButton": "Zurücksetzen",
          "clearGatesCancel": "Abbrechen",
          "activationSection": "Aktivierungsverlauf",
          "activatedBy": "Aktiviert von {name} am {date}",
          "neverActivated": "Noch nie vollständig aktiviert.",
          "close": "Schließen"
        },
        "toast": {
          "updated": "Feature Flag aktualisiert.",
          "error": "Aktion fehlgeschlagen. Bitte erneut versuchen."
        }
      }
    }
  }
}
